<app-side-nav [notifications$]="notifications$">
  <router-outlet></router-outlet>
</app-side-nav>

<app-tutorial-video-fab></app-tutorial-video-fab>
